<template>
  <div v-if="storedProject" class="admin-page__content">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <h2 class="mb-0">
          {{ $t("logOperaci") }}
        </h2>
        {{ $t("proProjekt") }} {{ storedProject.projectName }}
      </div>
      <!--button
        class="btn btn-primary d-flex align-items-center justify-content-center">
        <div class="atom-icon">
          <img src="@/assets/icons/actions/ico-btn-ulozit.svg">
        </div>
        {{ $t("ulozitZmeny") }}
      </button-->
    </div>
    <div class="mt-4">
      <CustomTableAjax
        v-if="endpoint"
        class="logs mobile-scrollable"
        :full-width="true"
        :endpoint="endpoint"
        :items="audits"
        :columns="[
          {
            name: 'timestamp',
            class: 'timestamp',
            sortable: true,
            filter: 'dateTime',
            separator: '<br />'
          },
          {
            name: 'DESCRIPTION',
            sortable: true,
            filter: 'replaceVariables',
            class: 'description'
          },
          { name: 'level', sortable: true },
          { name: 'projectId', sortable: true },
          { name: 'customerId', sortable: true },
          { name: 'originator', sortable: true }
        ]"
      />
    </div>
  </div>
</template>

<script>
import customTableAjax from "@/components/custom-table/table-ajax.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"

export default {
  components: {
    CustomTableAjax: customTableAjax
  },
  props: {
    project: Object
  },
  setup() {
    const projectStore = useProjectStore()
    const authStore = useAuthStore()

    return { projectStore, authStore }
  },
  data() {
    return {
      endpoint: false,
      total: 0,
      perPage: 20,
      offset: 100,
      audits: []
    }
  },
  computed: {
    storedProject() {
      return this.projectStore.selectedProject
    },
    apiUser() {
      return this.authStore.apiUser
    }
  },
  watch: {
    storedProject() {
      if (!this.endpoint) {
        this.endpoint = process.env.VUE_APP_API + "/audits/projects/" + this.storedProject.projectId
      }
    }
  },
  mounted() {
    if (this.storedProject) {
      this.endpoint = process.env.VUE_APP_API + "/audits/projects/" + this.storedProject.projectId
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>

/* 2021-04-27T14:34:34.347Z 2021-04-27T14:20:13.704Z */
